import styled from "styled-components";

export const StyledLabel = styled.label`
  ${({ theme }) => theme.fonts.mulishRegular};
  font-size: 11px;
  line-height: 1;
  letter-spacing: -0.025em;
  color: ${({ theme }) => theme.colors.darkGrey};
  display: block;
  margin-bottom: 8px;
  transition: color 0.3s;
  ${({ customStyle }) => customStyle && customStyle};
`;
